module.exports = __webpack_public_path__ + "img/V56.df83610e.jpg";